// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

//ENUMS
// eslint-disable-next-line no-unused-vars
import { BatterySort } from "@/enums/Battery/BatterySort.js";
// eslint-disable-next-line no-unused-vars
import { BatteryType } from "@/enums/Battery/BatteryType.js";

// ## Battery Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, sortBy: BatterySort, sortOrder: 'ASC' | 'DESC', type: BatteryType, isLocked: boolean, userId: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Battery.GetAll(option));

  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

// ## Battery Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, sortBy: BatterySort, sortOrder: 'ASC' | 'DESC', type: BatteryType, isLocked: boolean, userId: number }}} option
 *
 * @returns
 */
export const GetBatteryList = async (option) => {
  const response = await $api.get(Endpoints.Battery.GetBatteryList(option));

  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Battery Create
/**
 *
 * @param {{ "name": "string", "surname": "string", "email": "user@example.com", "phoneNo": "string", "password": "string", "role": BatteryRole}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Battery.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Battery Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Battery.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Battery Update
/**
 *
 * @param  {{ "name": "string", "surname": "string", "email": "user@example.com", "phoneNo": "string", "password": "string", "role": BatteryRole}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Battery.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Battery Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Battery.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Battery Create
/**
 *
 * @param {{ "name": "string", "surname": "string", "email": "user@example.com", "phoneNo": "string", "password": "string", "role": BatteryRole}} form
 *
 * @returns
 */
export const CalculateEvaporatorBattery = async (form) => {
  const response = await $api.post(
    Endpoints.Battery.CalculateEvaporatorBattery(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## Battery Create
/**
 *
 * @param {{ "name": "string", "surname": "string", "email": "user@example.com", "phoneNo": "string", "password": "string", "role": BatteryRole}} form
 *
 * @returns
 */
export const CalculateCondenserBattery = async (form) => {
  const response = await $api.post(
    Endpoints.Battery.CalculateCondenserBattery(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Battery UpdateLockStatus
/**
 *
 * @param {{ params: { id: string }, query: object}} option
 * @param {{isLocked: boolean}} form
 *
 * @returns
 */
export const UpdateLockStatus = async (option, form) => {
  const response = await $api.put(
    Endpoints.Battery.UpdateLockStatus(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Battery GetBatteryLogs
/**
 *
 * @param {{ query: { id: string, limit: number, page: number }, params: object}} option
 *
 * @returns
 */
export const GetBatteryLogs = async (option) => {
  const response = await $api.get(Endpoints.Battery.GetBatteryLogs(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## Battery ReactivateBattery
/**
 *
 * @param {{ id: number }} form
 *
 * @returns
 */
export const ReactivateBattery = async (form) => {
  const response = await $api.post(Endpoints.Battery.ReactivateBattery(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  GetBatteryList,
  Create,
  GetById,
  Update,
  Delete,
  CalculateEvaporatorBattery,
  CalculateCondenserBattery,
  UpdateLockStatus,
  GetBatteryLogs,
  ReactivateBattery,
};
